<template>
    <div class="input-group">
        <div class="input-group-prepend">
                    <span class="input-group-text">
                        <i class="fas fa-location-arrow"></i>
                    </span>
        </div>
        <gmap-autocomplete class="form-control" :placeholder="this.$t('indirizzo')"
                           :class="{'is-invalid': this.addressError}"
                           :options="{fields: ['geometry', 'formatted_address', 'address_components'], language: this.language, types:['address']}"
                           @place_changed="this.selectAddress" :value="address"/>
        <div class="input-group-append w-25" v-if="this.address && !this.street_number">
            <input type="text" class="form-control" :class="{'is-invalid': this.numberError}"
                   :placeholder="this.$t('numero')"
                   @input="onHouseNumberInput" :value="house_number">
        </div>
        <slot name="button"></slot>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "IncAutocomplete",
    props: ['defaultAddress', 'defaultHouseNumber', 'addressError', 'numberError'],
    data() {
        return {
            place: null,
            address: this.defaultAddress,
            house_number: this.defaultHouseNumber
        }
    },
    computed: {
        street_number: function () {
            if (this.place) {
                const streetNumber = this.place.address_components.find(
                    (address_component) => {
                        return address_component.types.includes('street_number');
                    },
                );

                if (streetNumber) {
                    return streetNumber.long_name;
                }
            }

            return null;
        },
        ...mapState('localization', {
            language: 'language'
        })
    },
    methods: {
        selectAddress: function (place) {
            this.place = place;
            this.address_error = false;
            if (this.place) {
                if (this.street_number) {
                    this.house_number = this.street_number;
                } else {
                    this.house_number = null;
                }
                this.address = this.place.formatted_address;
            }

            this.$emit('onAddressPick', this.place, this.address, this.house_number);
        },
        onHouseNumberInput: function (e) {
            this.house_number = e.target.value;

            this.$emit('onAddressPick', this.place, this.address, this.house_number);
        }
    }
}
</script>
